import { SettingsParser } from "./settings-parser";
import { DataSettings } from "../settings/data-settings";

export class DataSettingsParser extends SettingsParser {
  constructor(sourceParser, unitParser) {
    super();
    this.parsedFieldNames = [
      "isBuffered",
      "dataBufferSize",
      "units",
      "sources",
      "channels", // default source field
      "source" // from default settings
    ];
    this.sourceParser = sourceParser;
    this.unitParser = unitParser;
  }

  static createSettings(settings, defaultSettings, sourceParser, unitParser) {
    if (settings === undefined) {
      return undefined;
    }
    let parsedSettings = {};
    parsedSettings.isBuffered = settings.isBuffered ?? defaultSettings.isBuffered ?? false;
    parsedSettings.dataBufferSize = settings.dataBufferSize;
    parsedSettings.units = [];
    parsedSettings.sources = [];
    if (sourceParser !== undefined) {
      if (settings.sources === undefined) {
        if (settings.channels !== undefined) {
          let sourceSettings = {
            id: 0,
            channels: settings.channels
          };
          parsedSettings.sources.push(sourceParser.parse(sourceSettings, defaultSettings?.source));
        }
      } else if (settings.channels === undefined) {
        for (let sourceIndex = 0; sourceIndex < settings.sources.length; sourceIndex++) {
          parsedSettings.sources.push(sourceParser.parse(settings.sources[sourceIndex], defaultSettings?.source));
        }
      }
      if (settings.units !== undefined) {
        for (let unitIndex = 0; unitIndex < settings.units.length; unitIndex++) {
          parsedSettings.units.push(unitParser.parse(settings.units[unitIndex], defaultSettings?.unit));
        }
      }
    }
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    let parsedSettings = DataSettingsParser.createSettings(settings, defaultSettings, this.sourceParser, this.unitParser);
    if (parsedSettings === undefined) {
      return undefined;
    }
    SettingsParser.parseRestFields(settings, defaultSettings, this.parsedFieldNames, parsedSettings);
    return new DataSettings(parsedSettings);
  }
}
